module.exports = __webpack_public_path__ + "static/img/news9.3384c0f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/news9.png
// module id = 1fHx
// module chunks = 1